"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var percentageFormat = {
  input: function input(body) {
    if (!body) return body;
    return body.replace(/%{(.*?)}/g, '<span class="placeholder">$1<button>x</button></span>');
  },
  output: function output(body) {
    if (!body) return body;
    return body.replace(/<span\sclass=".*?placeholder.*?".*?>(.*?)<button>x<\/button>.*?<\/span>/g, '%{$1}');
  }
};
var _default = {
  percentageFormat: percentageFormat
};
exports["default"] = _default;
//# sourceMappingURL=placeholderConverters.js.map